import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { salesOrderService } from '../../../services/salesOrderService';
import VentasCommercialForm from '../../../components/Ventas/VentasCommercialForm';
import FormLoadingSpinner from '../../../components/Common/FormLoadingSpinner';
import Toast from '../../../components/Common/Toast';
import { POS_CONFIRMED_STATE } from '../../../utils/ventasPosNavigation';
import { formatDateToLima } from '../../../utils/dateUtils';

const EditVentasOrder = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [dayShiftClosed, setDayShiftClosed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    const loadOrder = async () => {
      try {
        const response = await salesOrderService.getOrder(id);
        if (response.success && response.data) {
          const loaded = { ...response.data, id: parseInt(id, 10) };
          setOrder(loaded);
          if (loaded.point_of_sale_id && loaded.issue_date) {
            try {
              const formRes = await salesOrderService.getFormData(loaded.point_of_sale_id);
              const dateKey = formatDateToLima(loaded.issue_date);
              const closedDates = formRes?.data?.closed_shift_dates || [];
              setDayShiftClosed(closedDates.includes(dateKey));
            } catch {
              setDayShiftClosed(false);
            }
          }
        } else {
          setToast({ isOpen: true, message: 'Venta no encontrada', type: 'error' });
          setTimeout(() => navigate('/ventas/orders', { state: POS_CONFIRMED_STATE }), 2000);
        }
      } catch {
        setToast({ isOpen: true, message: 'Error al cargar la venta', type: 'error' });
        setTimeout(() => navigate('/ventas/orders', { state: { posConfirmed: true } }), 2000);
      } finally {
        setLoading(false);
      }
    };
    if (id) loadOrder();
  }, [id, navigate]);

  const handleSuccess = () => {
    navigate('/ventas/orders', {
      replace: true,
      state: { ...POS_CONFIRMED_STATE, orderSavedMessage: 'Venta actualizada' },
    });
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="max-w-5xl mx-auto">
          <FormLoadingSpinner message="Cargando formulario…" hint="Preparando datos de la venta" />
        </div>
      </div>
    );
  }

  if (!order) return null;

  const readOnly = order.status === 'cancelled' || dayShiftClosed;

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">
            {readOnly ? 'Ver venta' : 'Editar venta'}
          </h1>
          <p className="text-gray-600 mt-1">
            {dayShiftClosed
              ? 'El turno de esta fecha está cerrado. Solo consulta.'
              : readOnly
                ? 'Consulta de la venta (no editable)'
                : 'Modifique la información de la venta'}
          </p>
          <div className="mt-2">
            <span className="text-sm font-mono text-teal-600">Código: {order.code}</span>
          </div>
        </div>
        <VentasCommercialForm
          mode="order"
          entity={order}
          readOnly={readOnly}
          isPageMode
          onClose={() => navigate('/ventas/orders', { state: POS_CONFIRMED_STATE })}
          onSuccess={handleSuccess}
        />
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default EditVentasOrder;
